/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthControllerService } from './services/auth-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthControllerService,
    ApiConfiguration
  ],
})
export class MyasiAuthPermissionsModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MyasiAuthPermissionsModule> {
    return {
      ngModule: MyasiAuthPermissionsModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MyasiAuthPermissionsModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MyasiAuthPermissionsModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
